import {Component, Input, OnInit} from '@angular/core';
import {JackingFormInstanceEditor, JackingFormSignaturesEditor, JackingSectionGroupTemplateEditor} from '../../../../../models/jacking-v2/jacking.models';
import {buildMissingFromRules, MissingFieldItem} from '../../helpers/jacking-missing-fields.helper';

@Component({
  selector: 'jacking-signatures',
  templateUrl: 'jacking-signatures.component.html'
})
export class JackingSignaturesComponent implements OnInit {
  @Input() editor: JackingFormInstanceEditor;
  @Input() group: JackingSectionGroupTemplateEditor;
  @Input() isReadonly: boolean = false;

  get signatures(): JackingFormSignaturesEditor {
    if (!this.editor) { return {} as any; }

    if (!this.editor.signatures) {
      this.editor.signatures = {
        jackingEngineer1SignerName: null,
        jackingEngineer1Signature: null,
        jackingEngineer2SignerName: null,
        jackingEngineer2Signature: null
      };
    }

    return this.editor.signatures;
  }

  ngOnInit() {
    if (!this.editor) { return; }
  }

}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-signatures/jacking-signatures.component.ts